/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keen_Mild_Fox_RestInputs */

const en_keen_mild_fox_rest = /** @type {(inputs: Keen_Mild_Fox_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`V1 (Deprecated)`)
};

const de_keen_mild_fox_rest = /** @type {(inputs: Keen_Mild_Fox_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`V1 (Veraltet)`)
};

/**
* | output |
* | --- |
* | "V1 (Deprecated)" |
*
* @param {Keen_Mild_Fox_RestInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const keen_mild_fox_rest = /** @type {((inputs?: Keen_Mild_Fox_RestInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keen_Mild_Fox_RestInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_keen_mild_fox_rest(inputs)
	return de_keen_mild_fox_rest(inputs)
});